import { curry, compose } from "ramda"
import isEmail from "./validators/isEmail"
import isCompanyNameEN from "./validators/isCompanyNameEN"
import isRequired from "./validators/isRequired"
import isRequiredFields from "./validators/isRequiredFields"
import isContactName from "./validators/isContactName"
import isCompanyNameCH from "./validators/isCompanyNameCH"
import isAddress from "./validators/isAddress"
import isAlphanumeric from "./validators/isAlphanumeric"
import isHKBrNumberFormat from "./validators/isHKBrNumberFormat"
import isNotHKBrNumberFormat from "./validators/isNotHKBrNumberFormat"
import { isAssociatedState, isAssociatedCity } from "./validators/isAssoiatedRegion"
import isAssociatedBRFields from "./validators/isAssociatedBRFields"
import isOptional from "./validators/isOptional"
import { isFieldNumber } from "./validators/isNumber"

export const getFieldValueObject = curry((fieldName, { value }) => {
  return { value: value[fieldName] }
})

const rules = {
  fields: {
    email: {
      isRequired,
      isEmail
    },
    nameEN: {
      isRequired,
      isCompanyNameEN
    },
    nameTC: {
      isCompanyNameTC: isOptional(isCompanyNameCH)
    },
    nameSC: {
      isCompanyNameSC: isOptional(isCompanyNameCH)
    },
    contactPerson: {
      isRequired: isRequiredFields(["title", "firstName", "lastName"], true),
      isFirstName: isContactName("firstName"),
      isLastName: isContactName("lastName")
    },
    telephone: {
      isRequired: isRequiredFields(["countryCode", "number"], true),
      isPhoneNumber: compose(isFieldNumber(30), getFieldValueObject("number")),
      isAreaCodeNumber: compose(isOptional(isFieldNumber(8)), getFieldValueObject("areaCode")),
      isExtensionNumber: compose(isOptional(isFieldNumber(15)), getFieldValueObject("extension"))
    },
    address: {
      isRequired: isRequiredFields(["firstRow", "secondRow", "thirdRow", "fourthRow"], false),
      isFirstRow: compose(isOptional(isAddress), getFieldValueObject("firstRow")),
      isSecondRow: compose(isOptional(isAddress), getFieldValueObject("secondRow")),
      isThirdRow: compose(isOptional(isAddress), getFieldValueObject("thirdRow")),
      isFourthRow: compose(isOptional(isAddress), getFieldValueObject("fourthRow"))
    },
    region: {
      country: {
        isRequired
      },
      state: {
        isAssociated: isAssociatedState(["region", "country"])
      },
      city: {
        isAssociated: isAssociatedCity(["region", "country"])
      }
    },
    natureOfBusiness: {
      isRequired
    },
    emailLangPef: {
      isRequired
    },
    saleRepCode: {
      isSaleRepCode: isOptional(isAlphanumeric(14))
    },
    BRDetails: {
      number: {
        isAssociated: isAssociatedBRFields([
          ["BRDetails", "file"],
          ["BRDetails", "commencementDate"],
          ["BRDetails", "expiryDate"]
        ]),
        isHKBRNumber: isOptional(isHKBrNumberFormat(20)),
        isNotHKBRNumber: isOptional(isNotHKBrNumberFormat(20))
      },
      commencementDate: {
        isAssociated: isAssociatedBRFields([
          ["BRDetails", "file"],
          ["BRDetails", "number"],
          // ["BRDetails", "commencementDate"],
          ["BRDetails", "expiryDate"]
        ])
      },
      expiryDate: {
        isAssociated: isAssociatedBRFields([
          ["BRDetails", "file"],
          ["BRDetails", "number"],
          ["BRDetails", "commencementDate"]
          // ["BRDetails", "expiryDate"]
        ])
      },
      file: {
        isAssociated: isAssociatedBRFields([
          // ["BRDetails", "file"],
          ["BRDetails", "number"],
          ["BRDetails", "commencementDate"],
          ["BRDetails", "expiryDate"]
        ])
      }
    }
  }
}

export default rules
